import React from "react";
import { Alert, Button, Card, Col, Descriptions, Form, Input, Modal, Row, Select, Tabs } from "antd";
import useModalEvaluacion from "../../hooks/useModalEvaluacion";
import PreguntasPuntualidad from "./PreguntasPuntualidad";
import useModalEvaluacionConductor from "../../hooks/useModalEvaluacionConductor";
import PreguntasComunicacionReportes from "./PreguntasComunicacionReportes";
import PreguntasResponsabilidadManejoVehiculo from "./PreguntasResponsabilidadManejoVehiculo";
import PreguntasActitudTrabajoEquipo from "./PreguntasActitudTrabajoEquipo";
import PreguntasImagenRepresentacionEmpresa from "./PreguntasImagenRepresentacionEmpresa";
import PreguntasPredisposicion from "./PreguntasPredisposicion";
import FactoresEvaluacion from "./FactoresEvaluacion";
import FactoresEvaluacionConductor from "./FactoresEvaluacionConductor";
import ObservacionResultado from "./ObservacionResultado";
import ResultadoEvaluacion from "./ResultadoEvaluacion";
import PlanAccionConductor from "./PlanAccionConductor";
import Renovacion from "./Renovacion";
import ResultadoEvaluacionConductor from "./ResultadoEvaluacionConductor";

const ModalEvaluacionConductor = () => {
	const { visibleModalEvaluacionConductor, onClickBtnEnviar, ocultarModal } = useModalEvaluacionConductor();

	return (
		<Modal
			title="FICHA DE EVALUACIÓN DE DESEMPEÑO LABORAL"
			open={visibleModalEvaluacionConductor}
			onCancel={ocultarModal}
			onOk={onClickBtnEnviar}
			okText="Evaluar"
			destroyOnClose={true}
			width={800}
		>
			<PreguntasPuntualidad />
			<PreguntasComunicacionReportes />
			<PreguntasResponsabilidadManejoVehiculo />
			<PreguntasActitudTrabajoEquipo />
			<PreguntasImagenRepresentacionEmpresa />
			<PreguntasPredisposicion />
			<FactoresEvaluacionConductor />
			<ObservacionResultado/>
			<ResultadoEvaluacionConductor />
			<PlanAccionConductor />
			<Renovacion />
		</Modal>
	);
};

export default ModalEvaluacionConductor;
